let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aWLQL")).then(() => parcelRequire('CgSs1'));